import { render, staticRenderFns } from "./add_result.vue?vue&type=template&id=6f219ceb&scoped=true&"
import script from "./add_result.vue?vue&type=script&lang=js&"
export * from "./add_result.vue?vue&type=script&lang=js&"
import style0 from "./add_result.vue?vue&type=style&index=0&id=6f219ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f219ceb",
  null
  
)

export default component.exports